import { useTranslation } from "react-i18next";
import { Money } from "./Money";

// 4 بطاقات KPI باستيلية بحدود ملوّنة + عدد ضخم + مجموع مالي أسفله.
const TILES = [
  { key: "overdue", tone: "rose",    bg: "bg-rose-500/8",    border: "border-rose-500/40",    text: "text-rose-500"  },
  { key: "paid",    tone: "emerald", bg: "bg-emerald-500/8", border: "border-emerald-500/40", text: "text-emerald-500" },
  { key: "partial", tone: "sky",     bg: "bg-sky-500/8",     border: "border-sky-500/40",     text: "text-sky-600" },
  { key: "pending", tone: "amber",   bg: "bg-amber-500/8",   border: "border-amber-500/40",   text: "text-amber-600" },
];

const CARD_3D = {
  boxShadow:
    "0 12px 24px rgba(0,0,0,0.20), 0 6px 10px rgba(0,0,0,0.14),"
    + " inset 0 1.5px 0 rgba(255,255,255,0.24), inset 0 -3px 8px rgba(0,0,0,0.12)",
};

export const BillsStats = ({ stats, active, onSelect }) => {
  const { t } = useTranslation();
  return (
    <div className="grid grid-cols-2 gap-4 xl:grid-cols-4" data-testid="bills-stats">
      {TILES.map(({ key, bg, border, text }) => (
        <button key={key} type="button"
                data-testid={`bills-stat-${key}`}
                onClick={() => onSelect(key)}
                style={CARD_3D}
                className={`animate-rise-in rounded-3xl border-2 p-5 text-center transition ${bg} ${border} ${
                  active === key ? "shadow-neu-in scale-[1.02]" : "hover:-translate-y-0.5"}`}>
          <p className={`num font-mono text-4xl font-black ${text}`}>{stats?.[key] ?? 0}</p>
          <p className="mt-1 text-sm font-bold text-foreground">{t(`acct.bills.stats.${key}`)}</p>
          <Money value={stats?.[`${key}_total`] || 0}
                 className={`mt-1 block text-xs font-mono font-bold ${text}`} />
        </button>
      ))}
    </div>
  );
};
